// src/utils/estado-partido.js — subestado + minuto del partido en vivo (presentación).
// Compartido por PRODE (src/modules/prode.js) y el home (src/modules/grupo.js) para
// que el bloque de estado (arriba a la derecha) sea idéntico en ambos.
//
// `status_detail` viene del adapter (ya mapeado a códigos en inglés); acá lo
// traducimos a español. `minuto` viene de la API (fx.status.elapsed).

// Código de status_detail → etiqueta en español.
export const SUBESTADO_LABELS = {
  first_half:       'Primer tiempo',
  halftime:         'Entretiempo',
  second_half:      'Segundo tiempo',
  extra_time:       'Alargue',
  extra_time_break: 'Descanso del alargue',
  penalties:        'Penales',
}

// Periodos con la pelota rodando: el minuto tiene sentido. En entretiempo,
// descanso del alargue y penales NO mostramos minuto (solo el subestado).
const PERIODOS_CON_MINUTO = new Set(['first_half', 'second_half', 'extra_time'])

// Traduce el código a español. null/desconocido → null.
export const subestadoLabel = (statusDetail) => SUBESTADO_LABELS[statusDetail] || null

// ¿Mostramos el minuto? Solo en periodos de juego y si hay minuto cargado.
export const minutoVisible = (statusDetail, minuto) =>
  PERIODOS_CON_MINUTO.has(statusDetail) && minuto != null

// Líneas 2 y 3 del bloque de estado en vivo (la línea 1 "EN VIVO" la pone el caller):
//   subestado: etiqueta traducida, o fallback 'En vivo' si no hay subestado.
//   minuto:    "45'" en periodos de juego, o null (entretiempo/penales/sin minuto).
export const lineasEstadoVivo = (partido) => ({
  subestado: subestadoLabel(partido?.status_detail) || 'En vivo',
  minuto: minutoVisible(partido?.status_detail, partido?.minuto) ? `${partido.minuto}'` : null,
})
